import { render, staticRenderFns } from "./ScoolSnackbar.vue?vue&type=template&id=ea7c506c"
import script from "./ScoolSnackbar.ts?vue&type=script&lang=ts&external"
export * from "./ScoolSnackbar.ts?vue&type=script&lang=ts&external"
import style0 from "./ScoolSnackbar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports